import { CopyButton, Grid, Typography } from '@kc-console/common-ui';
import { formatValueOrDefault } from '@kc-console/core';

import { EllipsisText } from '../EllipsisText';

import type { CopyableTextProps } from './types';

const CopyableText = (props: CopyableTextProps) => {
  const {
    value,
    typographyColor = 'text/default',
    typographyVariant = 'body/compact/md',
    ellipsis = false,
  } = props;

  const Text = ellipsis ? EllipsisText : Typography;

  return formatValueOrDefault({
    origin: value,
    formatter: value => (
      <Grid
        display="flex"
        alignItems="center"
        gap="8px"
        style={{ wordBreak: !ellipsis ? 'break-all' : 'normal' }}
      >
        <Grid>
          <Text variant={typographyVariant} color={typographyColor}>
            {value}
          </Text>
        </Grid>
        <CopyButton value={value} />
      </Grid>
    ),
  });
};

export default CopyableText;
